import { isDemoTab, leaveDemo } from "@/lib/auth/impersonation";
import { DESCOPE_PROJECT } from "@/lib/auth/descope-project";
import { DemoEvents, trackDemoEvent } from "@/lib/analytics";
import { loadPage } from "./navigate";

/**
 * Set in the tab once a demo session is minted, and cleared by the banner
 * when it sends `demo_started`: the mint reloads the page, and the event
 * belongs to the page the tracker loads on.
 */
export const DEMO_STARTED_FLAG = "headerhawk:demo-started";

/**
 * What every page gate says in a demo tab (task 453). A cold demo is a
 * challenge, a Descope impersonation, a reload and the first reads, each
 * possibly on a Lambda or a database that is waking, and a bare spinner
 * through all of it read as a page that had hung.
 */
export const DEMO_OPENING_LABEL = "Opening the demo…";

/** The page gates' label: `DEMO_OPENING_LABEL` in a demo tab, else none. */
export function gateLoaderLabel(): string | undefined {
  return isDemoTab() ? DEMO_OPENING_LABEL : undefined;
}

/**
 * Leave the demo for signup: the event first, then the session, so the
 * signup page this tab loads next is an ordinary one.
 */
export async function signUpFromDemo(location: string): Promise<void> {
  trackDemoEvent(DemoEvents.SIGNUP_CLICK, { location });
  await leaveDemo(DESCOPE_PROJECT);
  loadPage("/signup");
}
